import TextContentLoading from "./TextContentLoading";

type Props = {
  content: string;
  title: string;
  loading?: boolean;
};

export default function TextContent({ content, title, loading }: Props) {
  if (loading) {
    return <TextContentLoading />;
  }

  return (
    <section>
      <h3 className="text-theme-slate-700 text-2xl font-semibold leading-6 mb-6">
        {title}
      </h3>
      <div
        className="prose prose-slate max-w-none text-theme-slate-700 text-lg font-normal"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  );
}
